<div class="portada" id="pr">
<div class="sombra">
   <h2 (click)="portada()" style="opacity: 0"><img src="../../assets/web/nube.png" class="nube" /> Patagonia <br> Cloud </h2>
  
  <h1>
     PLANES 
  </h1>
</div>
</div>
<section class="plane">
<div class="contenedor">
    <div class="plan1 plan">
      <h1>TRAFUL</h1>
      <h2>BÁSICO </h2>
      <p class="mt">Web One Page</p>
      <p>Diseño web standard </p>
      <p>Hosting y Dominio</p>
      <p>Email coorporativo</p>
      <p>Formulario de contacto</p>
      <p>Responsive</p>
      <p>Diseño de Logo </p>
      <p>Hasta 2 propuestas de marca empresarial </p>
      <p>Ticket de soporte mensual</p>
    
      <div class="cotizar" (click) = "cotizar()">
        COTIZAR
      </div>

    </div>
    <div class="plan2 plan">

      <h1>FALKNER</h1>
      <h2>EMPRESARIAL </h2>
      <p class="mt">Sitio web personalizado</p>
      <p>Hosting, Dominio y Servidor dedicado / Email coorporativo</p>
      <p>Estudio de mercado digital </p>
      <p>E-commerce (productos y servicios)</p>
      <p>Campaña digital por redes</p>
      <p>Campaña SEO y SEM </p>  
      <p>Mantenimiento y Mejoras </p>
      <p>Asesoramiento personalizado </p>
      <p>Reuniones periódicas</p>
      <p>Soporte on-line 24hs </p>
      
     <div class="cotizar mtcot" (click) = "cotizar()">
        COTIZAR
      </div>


    </div>
    <div class="plan1 plan">
      <span>MÁS VENDIDO</span>
      <h1>LÁCAR</h1>
      <h2>AVANZADO </h2>
      <p class="mt">Sitio con hasta 5 secciones</p>
      <p>Hosting y Dominio / Email coorporativo</p>
      <p>Sección de blog / novedades</p>
      <p>Formulario de contacto</p>
      <p>Catálogo de productos autoadministrable</p>
      <p>Diseño de imagen empresarial </p>
      <p>Soporte on-line de Lunes a Viernes </p>

       <div class="cotizar " (click) = "cotizar()">
        COTIZAR
      </div>

    </div>
</div>
</section>

<div class="comenzahoy">
  <div class="sombra">
  <h1> COMIENZA HOY </h1>
    <div class="cotizar " (click) = "cotizar()">
        CONTACTAR
      </div>
  </div>
</div>

<div style="height: 400px">
  </div>